export const EMAIL_FORMAT = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const ZIP_CODE_FORMAT = /^([0-9]{7}|[0-9]{3}[-][0-9]{4})$/

export const TELEPHONE_FORMAT =
  /^(0[5-9]0[0-9]{8}|0[5-9]0[-][0-9]{4}[-][0-9]{4}|0[1-9][1-9][0-9]{7}|0[1-9]{2}[-][0-9]{3}[-][0-9]{4}|[+][0-9]{12,13})$/
